import { Button } from "react-bootstrap";

const TTButton: TTButtonProps = (props) => <Button {...props} />;

export default TTButton;
